var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useMemo, useState } from "react";
import { SaveButton, SimpleForm, useNotify, Toolbar, useGetList } from "react-admin";
import { Alert, Box, Accordion, AccordionDetails, AccordionSummary, MenuItem, FormControlLabel, Switch, Typography, } from "@mui/material";
import { ChannelIcon } from "@sequentech/ui-essentials";
import { useMutation } from "@apollo/client";
import MailIcon from "@mui/icons-material/Mail";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import EmailEditor from "@/components/EmailEditor";
import { useTranslation } from "react-i18next";
import { FormStyles } from "@/components/styles/FormStyles";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
import { CREATE_SCHEDULED_EVENT } from "@/queries/CreateScheduledEvent";
import { getReferencedSecretAttributeNames } from "@/services/secretAttributeTemplates";
import { ScheduledEventType } from "@/services/ScheduledEvent";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { EMessageChannel } from "@/types/messaging";
import { useMessagingAccounts } from "@/hooks/useMessagingAccounts";
import { useEventMessagingConfig } from "@/hooks/useEventMessagingConfig";
import { useLocation } from "react-router-dom";
import { buildSendTemplatePayload, missingChannelContent, sendNoticeChannels, sendableTemplates, sendingAccountFor, } from "./sendTemplatePayload";
import { SendTemplateAudience } from "./SendTemplateAudience";
import { ESendsFrom } from "@/queries/GetMessagingAudiencePreview";
import { ZonedDateTimeInput, } from "@/components/timezones/ZonedDateTimeInput";
import { useTimeZoneContext } from "@/components/timezones/useTimeZoneContext";
import { useTimeZoneService } from "@/components/timezones/timeZoneService";
export var AudienceSelection;
(function (AudienceSelection) {
    AudienceSelection["ALL_USERS"] = "ALL_USERS";
    AudienceSelection["NOT_VOTED"] = "NOT_VOTED";
    AudienceSelection["VOTED"] = "VOTED";
    AudienceSelection["SELECTED"] = "SELECTED";
})(AudienceSelection || (AudienceSelection = {}));
// Without an event configuration, notices go by SMS or email, in channel order.
var INSTANT_METHODS = [
    EMessageChannel.WHATSAPP,
    EMessageChannel.VIBER,
    EMessageChannel.MESSENGER,
];
var instantKey = function (method) {
    switch (method) {
        case EMessageChannel.WHATSAPP:
            return "whatsapp";
        case EMessageChannel.VIBER:
            return "viber";
        case EMessageChannel.MESSENGER:
            return "messenger";
        default:
            return undefined;
    }
};
/** Closing a channel keeps its editor mounted and its content in the send. */
var SendChannelSection = function (_a) {
    var channel = _a.channel, children = _a.children;
    var t = useTranslation().t;
    var id = React.useId();
    return (_jsxs(Accordion, { sx: { width: "100%", minWidth: 0 }, children: [_jsx(AccordionSummary, { id: "".concat(id, "-summary"), "aria-controls": "".concat(id, "-content"), expandIcon: _jsx(ExpandMoreIcon, {}), 
                // The always-open outer sections hide their arrows, including descendants.
                sx: { "&& .MuiAccordionSummary-expandIconWrapper": { display: "flex" } }, children: _jsxs(ElectionHeaderStyles.AccordionTitle, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(ChannelIcon, { channel: channel, fontSize: "small" }), t("template.method.".concat(channel.toLowerCase()))] }) }), _jsx(AccordionDetails, { sx: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }, children: children })] }));
};
export var SendTemplate = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var ids = _a.ids, audienceSelection = _a.audienceSelection, close = _a.close, electionEventId = _a.electionEventId, _h = _a.secretAttributeNames, secretAttributeNames = _h === void 0 ? [] : _h;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var location = useLocation();
    var notify = useNotify();
    var _j = useState(null), errors = _j[0], setErrors = _j[1];
    var createScheduledEvent = useMutation(CREATE_SCHEDULED_EVENT)[0];
    var _k = useState(false), showProgress = _k[0], setShowProgress = _k[1];
    var _l = useState(), audiencePreview = _l[0], setAudiencePreview = _l[1];
    // A time is entered in the event's primary zone, else the viewer's.
    var zones = useTimeZoneContext(electionEventId);
    var timeZones = useTimeZoneService();
    var _m = useState({
        audience: {
            selection: audienceSelection !== null && audienceSelection !== void 0 ? audienceSelection : AudienceSelection.SELECTED,
            voter_ids: ids !== null && ids !== void 0 ? ids : undefined,
        },
        schedule: {
            now: true,
            zoned: undefined,
        },
        i18n: {
            en: {
                email: {
                    subject: (_b = globalSettings.DEFAULT_EMAIL_SUBJECT["en"]) !== null && _b !== void 0 ? _b : "",
                    plaintext_body: (_c = globalSettings.DEFAULT_EMAIL_PLAINTEXT_BODY["en"]) !== null && _c !== void 0 ? _c : "",
                    html_body: (_d = globalSettings.DEFAULT_EMAIL_HTML_BODY["en"]) !== null && _d !== void 0 ? _d : "",
                },
                sms: {
                    message: (_e = globalSettings.DEFAULT_SMS_MESSAGE["en"]) !== null && _e !== void 0 ? _e : "",
                },
            },
        },
        language_conf: {
            enabled_languages: ["en"],
            default_language_code: "en",
        },
    }), template = _m[0], setTemplate = _m[1];
    var accounts = useMessagingAccounts({ skip: !electionEventId, summaries: true }).accounts;
    var _o = useEventMessagingConfig(electionEventId), storedConfig = _o.storedConfig, canReadMessaging = _o.canRead, messagingLoading = _o.loading;
    // The channels the backend will send on; nothing is guessed when they can't be read.
    var notices = useMemo(function () { return sendNoticeChannels(canReadMessaging, storedConfig); }, [canReadMessaging, storedConfig]);
    var noticeChannels = notices.kind === "CHANNELS" ? notices.channels : [];
    var sendsFrom = function (channel) {
        var _a;
        var account = sendingAccountFor(storedConfig, accounts, channel);
        if (account === "ENVIRONMENT")
            return t("messaging.send.environment");
        return (_a = account === null || account === void 0 ? void 0 : account.name) !== null && _a !== void 0 ? _a : t("messaging.send.noAccount");
    };
    var content = template.i18n["en"];
    var getPayload = function (formData) {
        var _a, _b, _c, _d, _e, _f;
        var templateContents = JSON.stringify(formData.i18n);
        return buildSendTemplatePayload({
            audienceSelection: formData.audience.selection,
            voterIds: formData.audience.voter_ids,
            scheduleNow: formData.schedule.now,
            scheduleDate: (_b = (_a = formData.schedule.zoned) === null || _a === void 0 ? void 0 : _a.scheduled_date) !== null && _b !== void 0 ? _b : undefined,
            scheduleLocal: (_d = (_c = formData.schedule.zoned) === null || _c === void 0 ? void 0 : _c.local) !== null && _d !== void 0 ? _d : undefined,
            scheduleTimezone: (_f = (_e = formData.schedule.zoned) === null || _e === void 0 ? void 0 : _e.timezone) !== null && _f !== void 0 ? _f : undefined,
            alias: formData.alias,
            content: formData.i18n["en"],
            secretAttributeNames: getReferencedSecretAttributeNames(templateContents, secretAttributeNames),
        });
    };
    var onSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var zoned, errors_1, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    zoned = (_a = formData.schedule) === null || _a === void 0 ? void 0 : _a.zoned;
                    setErrors(null);
                    if (electionEventId && notices.kind === "NONE") {
                        // Every voter's notice would be refused: nothing is scheduled.
                        setErrors(t("messaging.send.noNoticeChannels"));
                        return [2 /*return*/];
                    }
                    if (missing.length > 0) {
                        setErrors(t("messaging.send.missingContent", { channels: missing.map(channelName).join(", ") }));
                        return [2 /*return*/];
                    }
                    setShowProgress(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createScheduledEvent({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                eventProcessor: ScheduledEventType.SEND_TEMPLATE,
                                cronConfig: undefined,
                                eventPayload: getPayload(__assign(__assign({}, template), { schedule: { now: template.schedule.now, zoned: zoned } })),
                            },
                        })];
                case 2:
                    errors_1 = (_b.sent()).errors;
                    setShowProgress(false);
                    if (errors_1) {
                        setErrors(t("sendCommunication.errorSending", { error: errors_1.toString() }));
                        return [2 /*return*/];
                    }
                    else {
                        notify(t("sendCommunication.successSending"), { type: "success" });
                        close === null || close === void 0 ? void 0 : close();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setShowProgress(false);
                    setErrors(t("sendCommunication.errorSending", { error: String(error_1) }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateContent = function (next, alias) {
        if (alias === void 0) { alias = template.alias; }
        return setTemplate(__assign(__assign({}, template), { alias: alias, i18n: __assign(__assign({}, template.i18n), { en: __assign(__assign({}, content), next) }) }));
    };
    var handleNowChange = function (e) {
        var checked = e.target.checked;
        setTemplate(__assign(__assign({}, template), { schedule: __assign(__assign({}, template.schedule), { now: checked }) }));
    };
    var handleSmsChange = function (e) {
        return updateContent({ sms: { message: e.target.value } });
    };
    var handleInstantMessageChange = function (key) { return function (e) {
        var _a;
        var _b, _c;
        return updateContent((_a = {},
            _a[key] = __assign(__assign({}, content[key]), { parameters: (_c = (_b = content[key]) === null || _b === void 0 ? void 0 : _b.parameters) !== null && _c !== void 0 ? _c : [], message: e.target.value }),
            _a));
    }; };
    var handleSelectChange = function (e) {
        setAudiencePreview(undefined);
        setTemplate(__assign(__assign({}, template), { audience: __assign(__assign({}, template.audience), { selection: e.target.value }) }));
    };
    var receipts = useGetList("sequent_backend_template", {
        filter: {
            tenant_id: tenantId,
        },
    }).data;
    var selectableTemplates = useMemo(function () {
        return sendableTemplates((receipts !== null && receipts !== void 0 ? receipts : []).map(function (receipt) { return ({
            communication_method: receipt.communication_method,
            template: receipt.template,
        }); })).map(function (receipt) { return receipt.template; });
    }, [receipts]);
    var handleSelectAliasChange = function (e) {
        var _a, _b;
        var value = e.target.value;
        var selected = selectableTemplates.find(function (candidate) { return candidate.alias === value; });
        if (!selected) {
            return;
        }
        updateContent({
            email: (_a = selected.email) !== null && _a !== void 0 ? _a : content.email,
            sms: (_b = selected.sms) !== null && _b !== void 0 ? _b : content.sms,
            whatsapp: selected.whatsapp,
            viber: selected.viber,
            messenger: selected.messenger,
        }, value);
    };
    var setEmail = function (newEmail) { return updateContent({ email: newEmail }); };
    var validateDate = function (value) {
        if (!template.schedule.now && !(value === null || value === void 0 ? void 0 : value.scheduled_date)) {
            return t("sendCommunication.chooseDate");
        }
    };
    // Every voter gets this notification on their own channel: there's no other choice.
    var audienceChannels = audiencePreview
        ? audiencePreview.channels.flatMap(function (row) {
            return row.channel &&
                row.voters > row.not_offered &&
                row.sends_from &&
                row.sends_from !== ESendsFrom.NONE
                ? [row.channel]
                : [];
        })
        : noticeChannels;
    var missing = missingChannelContent(content, audienceChannels);
    var channelName = function (channel) { return t("messaging.channel.".concat(channel)); };
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsxs(SimpleForm, { toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { icon: _jsx(MailIcon, {}), label: String(t("sendCommunication.sendButton")), alwaysEnable: true }) }), record: template, onSubmit: onSubmit, sanitizeEmptyValues: true, children: [_jsx(PageHeaderStyles.Title, { children: t("sendCommunication.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("sendCommunication.subtitle") }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-voters" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.voters") }) }) }), _jsx(AccordionDetails, { children: _jsx(FormStyles.Select, { name: "audience.selection", value: template.audience.selection, onChange: handleSelectChange, children: Object.keys(AudienceSelection).map(function (key) {
                                    var _a, _b;
                                    return (_jsx(MenuItem, { value: key, children: t("sendCommunication.votersSelection.".concat(key), {
                                            total: (_b = (_a = template.audience.voter_ids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                                            voters: location.pathname.includes("user")
                                                ? t("sendCommunication.path.users")
                                                : t("sendCommunication.path.voters"),
                                        }) }, key));
                                }) }) })] }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-schedule" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.schedule") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(FormControlLabel, { label: String(t("sendCommunication.nowInput")), control: _jsx(Switch, { checked: template.schedule.now, onChange: handleNowChange }) }, "nowInput"), _jsx(ZonedDateTimeInput, { validate: validateDate, disabled: template.schedule.now, source: "schedule.zoned", label: String(t("sendCommunication.dateInput")), defaultZone: electionEventId ? zones.primary : timeZones.myTimeZone, zones: electionEventId ? zones.configured : undefined, primary: electionEventId ? zones.primary : undefined })] })] }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-method" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.methodTitle") }) }) }), _jsxs(AccordionDetails, { children: [electionEventId && notices.kind === "NO_PERMISSION" ? (_jsx(Alert, { severity: "info", children: t("messaging.send.noReadPermission") })) : null, electionEventId && notices.kind === "NONE" && !messagingLoading ? (_jsx(Alert, { severity: "error", children: t("messaging.send.noNoticeChannels") })) : null, electionEventId && noticeChannels.length > 0 ? (_jsx(SendTemplateAudience, { electionEventId: electionEventId, audienceSelection: template.audience.selection, voterIds: template.audience.voter_ids, channels: noticeChannels, sendsFrom: sendsFrom, onPreview: setAudiencePreview })) : null, _jsx(Typography, { variant: "caption", color: "text.secondary", component: "p", children: t("messaging.send.eachVoterHelp") }), _jsx(Typography, { variant: "body2", sx: { margin: "0" }, children: t("sendCommunication.alias") }), _jsx(FormStyles.Select, { name: "alias", value: template.alias || "", onChange: handleSelectAliasChange, children: selectableTemplates.map(function (candidate, index) { return (_jsx(MenuItem, { value: candidate.alias, children: candidate.alias }, index)); }) }), missing.length > 0 ? (_jsx(Alert, { severity: "warning", children: t("messaging.send.missingContent", {
                                        channels: missing.map(channelName).join(", "),
                                    }) })) : null, content.email && (_jsx(SendChannelSection, { channel: EMessageChannel.EMAIL, children: _jsx(EmailEditor, { record: content.email, setRecord: setEmail }) })), _jsx(SendChannelSection, { channel: EMessageChannel.SMS, children: _jsx(FormStyles.TextField, { name: "sms", label: String(t("sendCommunication.smsMessage")), value: (_g = (_f = content.sms) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", onChange: handleSmsChange, multiline: true, minRows: 4 }) }), INSTANT_METHODS.map(function (method) {
                                    var key = instantKey(method);
                                    if (!key) {
                                        return null;
                                    }
                                    var value = content[key];
                                    var editable = method === EMessageChannel.MESSENGER;
                                    if (!value) {
                                        return null;
                                    }
                                    var channel = t("template.method.".concat(key));
                                    return (_jsx(SendChannelSection, { channel: method, children: editable ? (_jsx(FormStyles.TextField, { name: key, label: String(channel), value: value.message, onChange: handleInstantMessageChange(key), multiline: true, minRows: 3 })) : (_jsxs(_Fragment, { children: [_jsx(Alert, { severity: "info", children: t("messaging.send.approvedTemplateHelp", {
                                                        channel: channel,
                                                    }) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: t("messaging.templates.approvedWording") }), _jsx(Typography, { component: "p", variant: "body2", sx: {
                                                                m: 0,
                                                                p: 2,
                                                                borderRadius: 1,
                                                                bgcolor: "action.hover",
                                                                whiteSpace: "pre-wrap",
                                                                overflowWrap: "anywhere",
                                                            }, children: value.message })] })] })) }, method));
                                })] })] }), _jsxs(FormStyles.StatusBox, { children: [showProgress ? _jsx(FormStyles.ShowProgress, {}) : null, errors ? (_jsx(FormStyles.ErrorMessage, { variant: "body2", children: errors })) : null] })] }) }));
};
